import { getBlockSize } from "@sperrdatei/dto/utils";

import type { ValidationResult } from "./validation-result";

export const validateNumberOrBlock = (
  value: string,
  isPrivate: boolean,
): ValidationResult => {
  if (value === "") {
    return { isValid: false, errorMessage: "Eingabe notwendig" };
  }

  if (!value.startsWith("0")) {
    return {
      isValid: false,
      errorMessage: "Die Rufnummer muss mit einer '0' beginnen.",
    };
  }

  if (value.indexOf("x") >= 0 && value.indexOf("*") >= 0) {
    return {
      isValid: false,
      errorMessage:
        "Die Verwendung von unterschiedlichen Platzhaltern ist unzulässig.",
    };
  }

  if (value.match(/x[0-9]|\*[0-9]/)) {
    return {
      isValid: false,
      errorMessage: "Ziffern hinter Platzhaltern sind unzulässig.",
    };
  }

  if (isPrivate && getBlockSize(value) > 11) {
    return {
      isValid: false,
      errorMessage:
        "Rufnummernblöcke ab einer Größe von 100 Nummern können nicht mit dem Kennzeichen Privat gesperrt werden.",
    };
  }

  if (getBlockSize(value) > 11111) {
    return {
      isValid: false,
      errorMessage:
        "Rufnummernblöcke dieser Größe können nicht gesperrt werden.",
    };
  }

  return { isValid: true };
};
